import { Fragment, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSignIn } from "react-auth-kit";
import { sendApiRequest } from "../../services/Base/base-service";

import {
  Form,
  FormGroup,
  Input,
  Button,
  Alert,
  Spinner,
  NotificationManager,
} from "design-react-kit";

import logo from "../../assets/logo.svg";
import classes from "../../assets/LoginForm.module.css";
import secureLocalStorage from "react-secure-storage";
import { notifyUser } from "../../services/helpers";
import { useContext } from "react";
import UserContext from "../../store/user-context";
import FormsFooter from "../FormsFooter";

const LoginFormMFA = () => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const signIn = useSignIn();

  const userEmail = secureLocalStorage.getItem("email");
  const userRememberMe = secureLocalStorage.getItem("rememberMe");
  const twoFactorAuthTokenTimeValidity = secureLocalStorage.getItem(
    "twoFactorAuthTokenTimeValidity"
  );

  const userContext = useContext(UserContext);

  const verifyTokenHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const token = document.getElementById("code").value;

    sendApiRequest(
      "Authentication/LoginTwoFactorAuth",
      "POST",
      false,
      {
        userName: userEmail,
        rememberMe: userRememberMe === null ? false : true,
        token,
      },
      signIn,
      null,
      navigate,
      null,
      userContext
    ).then((response) => {
      if (response.errors !== null) {
        setIsLoading(false);
        setError(response.errors);
      } else {
        setIsLoading(false);
      }
    });
  };

  const resendTokenHandler = (e) => {
    e.preventDefault();
    setIsLoading(true);
    sendApiRequest(
      "Authentication/ResendTwoFactorAuthCode",
      "POST",
      false,
      {
        userName: userEmail,
        twoFactorAuthResendToken: userContext.twoFactorAuthResendToken,
      },
      signIn,
      null,
      navigate
    ).then((response) => {
      if (response.errors !== null) {
        setError(response.errors);
        setIsLoading(false);
      } else {
        notifyUser(
          "Il codice è stato inviato nuovamente al tuo indirizzo di posta elettronica.",
          "success",
          "it-check",
          5000
        );
        setIsLoading(false);
      }
    });
  };

  return (
    <Fragment>
      <div className={classes["login-wrapper"]}>
        <div className={classes["left-side"]}>
          <img src={logo} alt="Logo" className={classes.logo} />
        </div>
        <div className={classes["right-side"]}>
          <div className="d-flex flex-column align-items-start mx-auto">
            <h4 className="text-center mt-3">Autenticazione a due fattori</h4>
            <p>
              Il codice è stato inviato al tuo indirizzo di posta elettronica.
              Inseriscilo entro i prossimi {twoFactorAuthTokenTimeValidity}{" "}
              minuti per completare l'accesso.
            </p>
          </div>
          {isLoading && (
            <p
              style={{
                height: "50px",
                position: "relative",
                marginBottom: "3rem",
              }}
            >
              <Spinner double active />
            </p>
          )}
          {error !== null && error.length !== undefined && (
            <Alert color="danger" className="w-50 ml-auto mr-auto">
              {error.map((item) => (
                <p key={item}>{item}</p>
              ))}
            </Alert>
          )}
          <Form className="mr-auto ml-auto">
            <div className="form-row">
              <FormGroup className="col-sm-12 m-0">
                <Input
                  id="code"
                  type="text"
                  placeholder="Inserisci il codice"
                  autoComplete="Code"
                />
              </FormGroup>
            </div>
            <FormGroup className="col-sm-12 mb-2 d-flex align-items-center justify-content-between">
              <Button
                color="primary"
                className="mr-2"
                onClick={(e) => navigate("/login")}
              >
                Vai al login
              </Button>
              <Button
                color="primary"
                type="submit"
                className="mr-2"
                onClick={(e) => verifyTokenHandler(e)}
              >
                Accedi
              </Button>
              <Button
                color="primary"
                type="submit"
                className="text-nowrap w-50"
                onClick={(e) => resendTokenHandler(e)}
              >
                Invia nuovamente il codice
              </Button>
            </FormGroup>
          </Form>
          <FormsFooter classes={classes} />
        </div>
      </div>
      <div>
        <NotificationManager
          containerId="twoFactorEnabled"
          fix="right"
          closeOnClick={true}
          state="success"
          duration={30000}
        />
      </div>
    </Fragment>
  );
};

export default LoginFormMFA;
